import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { SettingsProfil } from './profile';
import { SettingsNotifications } from './notifications';
import { SettingsUsers } from './users';

export const Settings = ({ roles }) => {
    return (
        <Switch>
            <Route exact path="/backoffice/settings">
                <SettingsProfil roles={roles} />
            </Route>
            {/* <Route path="/backoffice/settings/parametres" component={SettingsNotifications} /> */}
            {/* <Route path="/backoffice/settings/users" component={SettingsUsers} /> */}

            <Route render={() => {
                return <Redirect exact to="/backoffice/settings" />;
            }} />
        </Switch>
    );
};